import { formatMoment } from './query'

/**
 * Связь службы с аппаратом (FIX-C3). Кабинет AQSI признака «онлайн» не отдаёт —
 * состояние выводит служба из того, что наблюдала сама. Клиент только показывает.
 */
export type ConnectionState = 'online' | 'stale' | 'unreachable' | 'unknown' | 'cabinet-unavailable'

export const CONNECTION_STATES: readonly ConnectionState[] = [
  'online',
  'stale',
  'unreachable',
  'unknown',
  'cabinet-unavailable',
]

export interface AqsiDeviceConnection {
  state: ConnectionState
  /** Короткое слово службы: «На связи», «Касса не отвечает»… */
  title: string
  /** Текст службы для человека — дословно. Время в него не вписано: его показывает клиент. */
  message: string
  lastContactAt: string | null
  noAnswerSince: string | null
  cabinetUnavailableAt: string | null
}

export interface ConnectionVm {
  state: ConnectionState
  /** Слово службы и время в поясе браузера: «Касса на связи: 08.10, 14:32», «Касса не отвечает с 08.10, 14:32». */
  headline: string
  /** Что делать — текст службы; у «на связи» не нужен. */
  detail: string | null
}

/** Строка связи для экрана: слова — службы, время — клиента (CLAUDE.md §7: не только цвет — ещё значок и текст). */
export function connectionVm(connection: AqsiDeviceConnection | null): ConnectionVm | null {
  if (connection === null) return null
  switch (connection.state) {
    case 'online':
      return {
        state: connection.state,
        headline: connection.lastContactAt !== null ? `${connection.message}: ${formatMoment(connection.lastContactAt)}` : connection.message,
        detail: null,
      }
    case 'unreachable':
      return {
        state: connection.state,
        headline:
          connection.noAnswerSince !== null ? `${connection.title} с ${formatMoment(connection.noAnswerSince)}` : connection.title,
        detail: connection.message,
      }
    case 'cabinet-unavailable':
      return {
        state: connection.state,
        headline:
          connection.cabinetUnavailableAt !== null
            ? `${connection.title} с ${formatMoment(connection.cabinetUnavailableAt)}`
            : connection.title,
        detail: connection.message,
      }
    case 'stale':
      return {
        state: connection.state,
        headline:
          connection.lastContactAt !== null
            ? `${connection.title} — последний ответ ${formatMoment(connection.lastContactAt)}`
            : connection.title,
        detail: connection.message,
      }
    default:
      return { state: connection.state, headline: connection.title, detail: connection.message }
  }
}
